const IS_RELEASE = /release/.test(window.location.origin);

const PORTAL_BASE = (() => {
    const url = process.env.VUE_APP_PORTAL_BASE ?? "";
    if (IS_RELEASE) {
        return url.replace("b2b.", "b2b-release.");
    }
    return url;
})();

export default PORTAL_BASE;